import React from 'react';

import { IconTooltip } from 'utils/components/IconTooltip';

import './PortfolioSummaryTreemapHelp.scss';

export default function PortfolioSummaryTreemapHelp() {
    return (
        <IconTooltip className="PortfolioSummaryTreemapHelp" maxWidth={310}>
            <div>
                This chart displays the value breakdown (expressed as %) of a
                portfolio by a chosen grouping.
            </div>
            <div>
                The total value of each grouping is calculated as Buys + Sells
                (both are expressed as positive values).
            </div>
            <div>Filtering options allow the chart to be viewed by:</div>
            <ul>
                <li>Leaves: Unexecuted portion of order </li>
                <li>Traded: Executed portion of order </li>
                <li>Ordered: Total (Leaves and Traded)</li>
            </ul>
        </IconTooltip>
    );
}
